import React from "react"
import { SSEWrapper } from "./SSEWrapper"
import { PaymentLoader } from "../PaymentLoader"
import { CheckoutOrder } from "../../../models/order"
import { WalletPaymentIFrame } from "./WalletPaymentIFrame"

type Props = {
  showPaymentFailedScreen: (
    errorMessage?: string,
    providerName?: string
  ) => void
  showPaymentSucceededScreen: () => void
  src: string
  providerName: string
  order: CheckoutOrder
}

// MP / MP Transpayrent / Vipps
export const WalletPaymentForm = ({
  src,
  providerName,
  showPaymentFailedScreen,
  showPaymentSucceededScreen,
  order,
}: Props) => {
  return (
    <SSEWrapper
      showPaymentFailedScreen={showPaymentFailedScreen}
      showPaymentSucceededScreen={showPaymentSucceededScreen}
      order={order}
      renderChild={({
        startTimeout,
        sseSubscriber,
        paymentProcessing,
        timeoutId,
      }) => (
        <>
          {paymentProcessing ? (
            <PaymentLoader />
          ) : (
            <WalletPaymentIFrame
              src={src}
              order={order}
              providerName={providerName}
              showPaymentSucceededScreen={showPaymentSucceededScreen}
              showPaymentFailedScreen={showPaymentFailedScreen}
              sseSubscriber={sseSubscriber}
              startTimeout={startTimeout}
              timeoutId={timeoutId}
            />
          )}
        </>
      )}
    />
  )
}
